<template>

    <Page>

        <ImageAndText 
            src="/ExecutiveSummary/executive-summary-3.jpg"
            animation="slide-up"
            border
            image-class="rounded-xl"
            floor-shadow
            :flip="true">

            <h2 class="text-xl">£10 – £30M+ Annual Upside</h2>
            <p class="font-light text-white/80 italic mb-4 text-xl">
                Conservative projection from initial UK partners alone
            </p>
            <ul class="font-normal text-white/80 list-disc pl-5 text-xl">
                <li class="pl-3 mb-3 leading-tight">Immediate multi-million-pound revenue potential.</li>
                <li class="pl-3 mb-3 leading-tight">Built on proven, scalable adoption models.</li>
                <li class="pl-3 leading-tight">Significant upside as we expand across the market.</li>
            </ul>

        </ImageAndText>

    </Page>

</template>